const schema_schedule = {
    requested_hour: {
        label: "What is the best time to contact you?",
        value: null,
        type: "radio",
        required: true,
        options: [
            {key: 10, value: "10-11"},
            {key: 11, value: "11-12"},
            {key: 12, value: "12-13"},
            {key: 13, value: "13-14"},
            {key: 14, value: "14-15"},
            {key: 15, value: "15-16"},
            {key: 16, value: "16-17"},
        ],
    }
};
export default schema_schedule;
